/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    IsAvailableResponse,
    IsAvailableResponseFromJSON,
    IsAvailableResponseToJSON,
} from '../models';

export interface ApiDeliveryAvailablePostalCodeGetRequest {
    postalCode: string;
}

export interface ApiDeliveryValidatePostalCodeCityGetRequest {
    postalCode: string;
    city: string;
}

/**
 * no description
 */
export class DeliveryApi extends runtime.BaseAPI {

    /**
     * Check delivery availability for postal code
     */
    async apiDeliveryAvailablePostalCodeGetRaw(requestParameters: ApiDeliveryAvailablePostalCodeGetRequest): Promise<runtime.ApiResponse<IsAvailableResponse>> {
        if (requestParameters.postalCode === null || requestParameters.postalCode === undefined) {
            throw new runtime.RequiredError('postalCode','Required parameter requestParameters.postalCode was null or undefined when calling apiDeliveryAvailablePostalCodeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/deliveryAvailable/{postalCode}`.replace(`{${"postalCode"}}`, encodeURIComponent(String(requestParameters.postalCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IsAvailableResponseFromJSON(jsonValue));
    }

    /**
     * Check delivery availability for postal code
     */
    async apiDeliveryAvailablePostalCodeGet(postalCode: string): Promise<IsAvailableResponse> {
        const response = await this.apiDeliveryAvailablePostalCodeGetRaw({ postalCode: postalCode });
        return await response.value();
    }

    /**
     * Validate delivery for postal code and city
     */
    async apiDeliveryValidatePostalCodeCityGetRaw(requestParameters: ApiDeliveryValidatePostalCodeCityGetRequest): Promise<runtime.ApiResponse<IsAvailableResponse>> {
        if (requestParameters.postalCode === null || requestParameters.postalCode === undefined) {
            throw new runtime.RequiredError('postalCode','Required parameter requestParameters.postalCode was null or undefined when calling apiDeliveryValidatePostalCodeCityGet.');
        }
        if (requestParameters.city === null || requestParameters.city === undefined) {
            throw new runtime.RequiredError('city','Required parameter requestParameters.city was null or undefined when calling apiDeliveryValidatePostalCodeCityGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};
        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/deliveryValidate/{postalCode}/{city}`
                .replace(`{${"postalCode"}}`, encodeURIComponent(String(requestParameters.postalCode)))
                .replace(`{${"city"}}`, encodeURIComponent(String(requestParameters.city))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IsAvailableResponseFromJSON(jsonValue));
    }

    /**
     * Validate delivery for postal code and city
     */
    async apiDeliveryValidatePostalCodeCityGet(postalCode: string, city: string): Promise<IsAvailableResponse> {
        const response = await this.apiDeliveryValidatePostalCodeCityGetRaw({ postalCode, city });
        return await response.value();
    }

}
